// src/helpers.ts

import axios from "axios";

export const getApiUrl = () => {
  // Check for explicit environment variable first
  const envEndpoint = process.env.REACT_APP_GRAPHQL_ENDPOINT;

  if (envEndpoint) {
    console.log("Using GraphQL endpoint from env:", envEndpoint);


    return envEndpoint;
  }

  // Default to production unless explicitly set to development
  const isDevelopment = process.env.REACT_APP_ENV === "development";
  const endpoint = isDevelopment
    ? "http://localhost:4000/graphql"
    : "https://business-builder-backend-sy9bw.ondigitalocean.app/graphql";

  console.log("Using GraphQL endpoint:", endpoint);
  return endpoint;
};


export const getBitcoinPrice = async (): Promise<number> => {
  try {
    const response = await axios.get("https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=aud");
    return response.data.bitcoin.aud;
  } catch (error) {
    console.error("Error fetching BTC price:", error);
    return 0; // Return 0 or some default value in case of an error
  }
};

export const calculateBTCAmount = (audAmount: number, btcPrice: number): number => {
  return audAmount / btcPrice;
};

/**
 * Ensures an IPFS gateway URL has the https:// protocol.
 */
export const normalizeIpfsUrl = (url: string): string => {
  if (!url) return url;

  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  if (url.includes('files.tommillerservices.com')) {
    return `https://${url}`;
  }

  return url;
};

/**
 * Normalizes a media URL for display.
 */
export const normalizeMediaUrl = (url?: string): string => {
  if (!url) return '';
  return normalizeIpfsUrl(url);
};